// stateAbbreviations.js
// Comprehensive mapping for US states and Canadian provinces
// Handles full names, abbreviations, and case variations

export const STATE_ABBREVIATIONS = {
  // US States - full names
  "alabama": "AL",
  "alaska": "AK",
  "arizona": "AZ",
  "arkansas": "AR",
  "california": "CA",
  "colorado": "CO",
  "connecticut": "CT",
  "delaware": "DE",
  "florida": "FL",
  "georgia": "GA",
  "hawaii": "HI",
  "idaho": "ID",
  "illinois": "IL",
  "indiana": "IN",
  "iowa": "IA",
  "kansas": "KS",
  "kentucky": "KY",
  "louisiana": "LA",
  "maine": "ME",
  "maryland": "MD",
  "massachusetts": "MA",
  "michigan": "MI",
  "minnesota": "MN",
  "mississippi": "MS",
  "missouri": "MO",
  "montana": "MT",
  "nebraska": "NE",
  "nevada": "NV",
  "new hampshire": "NH",
  "new jersey": "NJ",
  "new mexico": "NM",
  "new york": "NY",
  "north carolina": "NC",
  "north dakota": "ND",
  "ohio": "OH",
  "oklahoma": "OK",
  "oregon": "OR",
  "pennsylvania": "PA",
  "rhode island": "RI",
  "south carolina": "SC",
  "south dakota": "SD",
  "tennessee": "TN",
  "texas": "TX",
  "utah": "UT",
  "vermont": "VT",
  "virginia": "VA",
  "washington": "WA",
  "west virginia": "WV",
  "wisconsin": "WI",
  "wyoming": "WY",
  "district of columbia": "DC",
  "washington dc": "DC",

  
  "ontario": "ON",
  "quebec": "QC",
  "british columbia": "BC",
  "alberta": "AB",
  "saskatchewan": "SK",
  "manitoba": "MB",
  "nova scotia": "NS",
  "new brunswick": "NB",
  "newfoundland and labrador": "NL",
  "newfoundland": "NL",
  "newfoundland labrador": "NL",
  "prince edward island": "PE",
  "pei": "PE",
  "yukon": "YT",
  "northwest territories": "NT",
  "nunavut": "NU",

  "al": "AL", "ak": "AK", "az": "AZ", "ar": "AR", "ca": "CA", "co": "CO", "ct": "CT",
  "de": "DE", "fl": "FL", "ga": "GA", "hi": "HI", "id": "ID", "il": "IL", "in": "IN",
  "ia": "IA", "ks": "KS", "ky": "KY", "la": "LA", "me": "ME", "md": "MD", "ma": "MA",
  "mi": "MI", "mn": "MN", "ms": "MS", "mo": "MO", "mt": "MT", "ne": "NE", "nv": "NV",
  "nh": "NH", "nj": "NJ", "nm": "NM", "ny": "NY", "nc": "NC", "nd": "ND", "oh": "OH",
  "ok": "OK", "or": "OR", "pa": "PA", "ri": "RI", "sc": "SC", "sd": "SD", "tn": "TN",
  "tx": "TX", "ut": "UT", "vt": "VT", "va": "VA", "wa": "WA", "wv": "WV", "wi": "WI",
  "wy": "WY", "dc": "DC",
  "on": "ON", "qc": "QC", "bc": "BC", "ab": "AB", "sk": "SK", "mb": "MB",
  "ns": "NS", "nb": "NB", "nl": "NL", "pe": "PE", "yt": "YT", "nt": "NT", "nu": "NU"
};

export const getStateCode = (region) => {
  if (!region || typeof region !== 'string') {
    return '';
  }
  const cleaned = region.trim().replace(/\s+/g, ' ').toLowerCase();

  if (/^[a-zA-Z]{2}$/.test(cleaned)) {
    return cleaned.toUpperCase();
  }

  const code = STATE_ABBREVIATIONS[cleaned];
  if (code) {
    return code;
  }

  return region.trim();
};